import { isHttpClientErrorOf } from '@deepcloud/api-http-client'
import { useDeepBoxDeepValidatorOpenAction } from '@deepcloud/deep-ui-kit'
import { humanFileSize } from '@deepcloud/deep-ui-utils'
import { useKeycloak } from '@/composables/auth/keycloak.ts'
import type { ProblemDetail } from '@deepcloud/api-deep-validator'

export function useDeepValidatorOpen() {
  const { t } = useI18n()
  const { bearer } = useKeycloak()
  const env = import.meta.env.VITE_ENVIRONMENT

  const { execute, config } = useDeepBoxDeepValidatorOpenAction(
    computed(() => bearer.value ?? ''),
    env,
  )

  function getErrorMessage(error: unknown): string {
    if (isHttpClientErrorOf<ProblemDetail>(error)) {
      const maxSizeBytes = (
        error.response?.data?.properties as { maxSizeBytes?: string }
      )?.maxSizeBytes

      if (maxSizeBytes) {
        return t('messages.error.deepvalidator_file_max_size', {
          size: humanFileSize(Number(maxSizeBytes), 0),
        })
      }

      if (error.response?.data?.detail) {
        return error.response.data.detail
      }
    }

    return t('error.error_occurred')
  }

  return { execute, config, getErrorMessage }
}
